"use client";

import React from "react";
import { styled } from "styled-components";
import { css } from "@emotion/react";

import IcoClose from "@src/assets/ico_close.png";
import { transferToNative } from "@src/lib/WebAppBridge";

export type ImgSrc = string;

interface Props {
    imgMobile?: ImgSrc;
    buttonText?: string;
    onClickButton?: () => void;
    onClickHref?: string;
    onClose?: () => void;
    faqBackgroundStyle?: any;
    buttonStyle?: any;
    imgStyle?: any;
    contents?: any;
    showButton?: boolean;
}

const EventPage = ({
    imgMobile,
    buttonText,
    onClickButton,
    onClickHref,
    onClose,
    faqBackgroundStyle,
    buttonStyle,
    imgStyle,
    contents,
    showButton = true,
}: Props) => {
    const handleClickButton = onClickButton ?? (onClickHref ? () => {} : () => {});

    return (
        <Layout>
            <div css={titleBoxStyle}>
                <div className="title">AI 예상배당표 신기능 출시</div>
                <button className="close-icon" onClick={() => transferToNative("done", "closeWebView")}>
                    <img src={IcoClose} alt="close" />
                </button>
            </div>
            <ImgRootBoxStyle>
                <ImgMobile src={imgMobile} alt="" style={imgStyle} />
                {contents}
            </ImgRootBoxStyle>
        </Layout>
    );
};

export default EventPage;

const Layout = styled.div`
    display: flex;
`;

const ImgRootBoxStyle = styled.div`
    position: relative;
    height: 100vh;
    overflow-y: auto;

    -ms-overflow-style: none;
    scrollbar-width: none;
    &::-webkit-scrollbar {
        width: 0;
    }

    .closeBtn {
        position: fixed;
        right: 24px;
        top: 102px;
        cursor: pointer;
        width: 66px;
        height: 66px;

        @media (max-width: 768px) {
            top: 32px;
            right: 16px;
            width: 40px;
            height: 40px;
        }
    }
`;

const imgBase = css`
    display: block;
    margin: 58px auto 0;
    width: 100vw;
    height: auto;

    @media (max-width: 768px) {
        margin: 0;
    }
`;

const ImgMobile = styled.img`
    ${imgBase}
    display: none;

    @media (max-width: 768px) {
        display: block;
    }
`;

const titleBoxStyle = css`
    position: fixed;
    top: 0;
    display: flex;
    justify-content: center;
    flex: 1;
    width: 100%;
    height: 58px;
    border-radius: 0px;
    padding: 14px;

    & .title {
        font-size: 18px;
        font-weight: 700;
        line-height: 28px;
        letter-spacing: 0px;
        color: #0c002c;
    }

    & .close-icon {
        position: absolute;
        right: 14px;
        top: 50%;
        transform: translateY(-50%);
        height: 14px;

        img {
            width: 14px;
            height: 14px;
        }
    }
`;
